<template>
  <form :action="window.contextPath + '/search'" method="get" class="input-group" v-click-outside="deactivate">
    <span @click="activate" class="input-group-text">
      <i class="fa-light fa-search"></i>
    </span>
    <transition mode="out-in" name="fade-in">
      <input v-if="active"
             name="q"
             ref="searchInput"
             type="text"
             v-model="query"
             class="form-control"
             :placeholder="bundle.id_10906"/>
      <button v-else=""
              type="button"
              @click.prevent="activate"
              class="btn btn-link">
        {{ bundle.id_9206 }}
      </button>
    </transition>
  </form>
</template>

<script>
import Vue from "vue";

export default {
  name: "global-search-icon",
  data: function () {
    return {
      activated: false,
      query: "",
      bundle: {
        id_9206: "Search",
        id_10906: "Enter keywords...",
      },
    }
  },
  created: function () {
    Vue.$bundle("portal", this.bundle, (bundle) => {
      this.bundle = bundle;
    });
    if (window.location.pathname === `${window.contextPath}/search`) {
      const urlParams = new URLSearchParams(window.location.search);
      const q = urlParams.get("q");
      if (q) {
        this.query = q;
      }
    }
  },
  computed: {
    active: function () {
      return this.activated || this.query.length;
    }
  },
  methods: {
    activate: function () {
      this.activated = true;
      this.$nextTick(() => {
        let checks = 0;
        const interval = setInterval(() => {
          checks++;
          if (checks > 100 || this.$refs.searchInput) {
            this.$refs.searchInput.focus();
            clearInterval(interval);
          }
        }, 10);
      });
    },
    deactivate: function () {
      this.activated = false;
    }
  }
}
</script>

<style scoped lang="less">
.fade-in-enter-active,
.fade-in-leave-active {
  transition: opacity .1s ease;
}

.fade-in-enter,
.fade-in-leave-to {
  opacity: 0;
}

.input-group {
  .input-group-text {
    background-color: transparent;
    border-color: transparent;
    padding-left: 0;
    padding-right: 0;
    border-left: none;
    border-right: none;
  }

  .btn, .form-control {
    background-color: transparent;
    border-color: transparent;
    font-size: .875rem;
    padding-left: .5rem;
    padding-right: 0;

    &:active, &:focus, &:hover {
      box-shadow: none;
    }
  }

  &:has(.input-group-text:hover) {
    cursor: pointer;

    .btn {
      text-decoration: underline;
    }
  }
}
</style>